/* ---------------------------------------------------------------------------------------------------------------------
BOOK A STORAGE CONTAINER JS
--------------------------------------------------------------------------------------------------------------------- */
jQuery(document).ready(function ($) {
    var $bookingFormWrapper = $('#booking_form_wrapper');
    if ($bookingFormWrapper.length === 0) {
        return;
    }

    var $bookingForm = $bookingFormWrapper.find('form.booking-form'),
        $bookNowPopout = $bookingFormWrapper.find('#book_storage_popout'),
        $containerSelect = $bookingForm.find('select[name=container_number]'),
        containerDummy = $containerSelect.find('option').eq(1),
        containers = self_storage_units.stock_availabilities;

    if ($bookingForm.find('select[name=storage_type]').prop('selectedIndex') > 0 && $bookingForm.find('select[name=container_parent]').prop('selectedIndex') === 0) {
        setTimeout(function () {
            $bookingForm.find('select[name=storage_type]').trigger('change');
        }, 50);
    } else if ($bookingForm.find('select[name=container_parent]').prop('selectedIndex') > 0 && $bookingForm.find('select[name=container_number]').prop('selectedIndex') === 0) {
        setTimeout(function () {
            $bookingForm.find('select[name=container_parent]').trigger('change');
        }, 50);
    } else if ($bookingForm.find('select[name=container_number]').prop('selectedIndex') > 0) {
        setTimeout(function () {
            var containerId = $bookingForm.find('select[name=container_number] option:selected').data('container-id');
            $bookingForm.trigger('unit_selected', self_storage_units.stock_availabilities[containerId]);
        }, 50);
    }

    $bookingForm.on('unit_selected', function (e, container) {
        getStorageUnitsFromParentId(container.parent_id);
        $bookingForm.find('select[name=storage_type] option[value='+ container.unit_type + ']').prop('selected', true);
        getStorageSizes(container.unit_type, container.parent_id);
        $bookingForm.find('#select_container_wrapper').show();
        $bookingForm.find('select[name=container_number] option[value='+ container.id + ']').prop('selected', true);
        getStorageUnits();
    });

    $bookingForm.on('change', 'select[name=storage_type]', function (e) {
        var $this = $('option:selected', this);

        $bookingForm.find('p.booking-storage-type-notice').hide();
        $bookingForm.find('#select_container_wrapper').hide();
        $bookingForm.find('select[name=container_number]').val('');
        $bookingForm.trigger('refresh_storage_units', this.value);
        $bookNowPopout.find('.out-of-stock').remove();
        $bookNowPopout.find('.book-a-storage-container__popout').remove();

        var selectedSize = $this.val();
        if (selectedSize === 'warehouse') {
            $bookingForm.find('#select_storage_size_wrapper').hide();
            $bookingForm.find('#select_storage_type_wrapper').append('<p class="booking-storage-type-notice">To Book Warehouse Space, or enquire about office and warehouse/storage combinations, then we will need a few more details from you, then we will call you to make the reservation, click here to go to our office information page, or re-select one of the other storage options.</p>');
        }
        else if(selectedSize === 'office') {
            $bookingForm.find('#select_storage_size_wrapper').hide();
            $bookingForm.find('#select_storage_type_wrapper').append('<p class="booking-storage-type-notice">To Book Office Space or Desk Space we will need a few more details from you, then we will call you to make the reservation, click here to go to our office information page, or re-select one of the other storage options.\n</p>');
        }
        else {
            getStorageSizes(selectedSize);
        }
    });

    $bookingForm.on('change', 'select[name=container_parent]', function (e) {
        var $this = $('option:selected', this),
            parentId = $this.data('product-id');

        let label;
        if ($this.data('unit-type') === 'storage_room') {
            label = '4. Select room number';
        } else if ($this.data('unit-type') === 'container') {
            label = '4. Select container number';
        } else {
            label = '4. Select unit number';
        }

        $('label[for="select_container"]').text(label);

        getStorageUnitsFromParentId(parentId);
        $bookingForm.find('select[name=container_number]').val('');
        $bookingForm.trigger('refresh_storage_units', $bookingForm.find('select[name=storage_type]').val());
        getStorageUnits();
    });

    $bookingForm.on('change', 'select[name=container_number]', function (e) {
        $bookingForm.trigger('storage_unit_changed', this.value);
        getStorageUnits();
    });

    function getStorageUnitsFromParentId(parentId)
    {
        $bookingForm.find('select[name=container_number] option').not(':eq(0)').remove();

        for (var key in containers) {
            if (containers.hasOwnProperty(key) && containers[key].parent_id === parentId) {
                var container = containers[key];
                var $containerOption = containerDummy.clone();

                $containerOption.attr('data-container-id', key)
                    .attr('data-container-status', container.stock_status)
                    .attr('data-container-parent-id', container.parent_id)
                    .val(container.id).text(key).show();

                if (container.stock_status === 'outofstock') {
                    $containerOption.addClass('d-none');
                }

                $containerSelect.append($containerOption);
            }
        }
    }

    function getStorageSizes(type, selected)
    {
        $bookingForm.find('#select_storage_size_wrapper').show();
        $bookingForm.find('select[name=container_parent] option').not(':eq(0)').hide();
        $bookingForm.find('select[name=container_parent] option[data-unit-type='+ type + ']').show();

        if (selected) {
            $bookingForm.find('select[name=container_parent] option[data-product-id=' + selected+ ']').prop('selected', true);
        } else {
            $bookingForm.find('select[name=container_parent] option').eq(0).prop('selected', true);
        }
    }

    function getStorageUnits() {
        $.ajax({
            url: self_storage.ajax_url,
            type: "POST",
            dataType: "json",
            data: {
                'action': 'get_storage_units',
                'data': $bookingForm.serialize(),
            },
            beforeSend: function () {
                $bookNowPopout.block({
                    message: null,
                    overlayCSS: {
                        background: '#fff',
                        opacity: 0.6
                    }
                });
                $bookNowPopout.find('.out-of-stock').remove();
                $bookNowPopout.find('.book-a-storage-container__popout').remove();
            },
        }).success(function (response) {
            if (typeof response.out_of_stock !== 'undefined' && response.out_of_stock.length > 0) {
                $bookNowPopout.append(response.out_of_stock);
                $containerSelect.parent('#select_container_wrapper').hide();
            } else {
                $containerSelect.parent('#select_container_wrapper').show();

                /** Append response */
                if (typeof response.product !== 'undefined' && response.product.length > 0) {
                    $bookNowPopout.append(response.product);

                    /** Re init $variations_form */
                    var $variations_form = $bookNowPopout.find('form.variations_form');
                    $variations_form.wc_variation_form();

                    // $bookingForm.trigger('found_variation', $variations_form);

                    /** Prevent image update on variation */
                    $variations_form.wc_variations_image_update = function () {
                        return false;
                    };

                    //$popoutSlider.slick('reinit');
                   // initSliders();
                } else {
                    // $bookingForm.append(response);
                }
            }
            $bookNowPopout.unblock();

            acf.do_action('append', $('#acf-waiting-list-form'));

            $('html, body').animate({
                scrollTop: $bookNowPopout.offset().top - 20,
            }, 'slow');
        });
        return false;
    }

    $(document).on('change', '.variation-radios input', function () {
        $('.variation-radios input:checked').each(function (index, element) {
            var $el = $(element);
            var thisName = $el.attr('name');
            var thisVal = $el.attr('value');
            $('select[name="' + thisName + '"]').val(thisVal).trigger('change');
        });
    });

    $(document).on('woocommerce_update_variation_values', function () {
        $('.variation-radios input').each(function (index, element) {
            var $el = $(element);
            var thisName = $el.attr('name');
            var thisVal = $el.attr('value');
            $el.removeAttr('disabled');
            if ($('select[name="' + thisName + '"] option[value="' + thisVal + '"]').is(':disabled')) {
                $el.prop('disabled', true);
            }
        });
    });
});
